module.exports = __webpack_public_path__ + "static/media/peso_verde.fd64ffbe.svg";